export const TABS_IDS = {
  requestTab: 'directSale-requestTab',
  fastTrackIssues: 'directSale-fastTrackIssues',
  discountTab: 'directSale-discountTab',
  checkoutTab: 'directSale-checkoutTab',
};
